import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import Identity from '../identity';
import Projects from '../projects';
import SnackBar from '../projects/components/snackBar/SnackBar';

const ProfileLayout: React.FC<IProps<IDeveloper>> = ({ data }) => {
  return (
    <Box sx={{ py: 6, position: 'relative' }}>
      <SnackBar />
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Identity data={data} />
          </Grid>
          <Grid item xs={12} md={8}>
            <Projects data={data} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ProfileLayout;
